const USER_ROLES = [
    { label: 'admin', value: 'admin' },
    { label: 'user', value: 'user' },
    { label: 'viewer', value: 'viewer' },
];

export default USER_ROLES;
